import axios from 'axios';
import { Helpers } from '../helpers/Helpers';

/**
 * Aylık Puantaj (İnsan Kaynakları > Aylık Puantaj, QR Mesai Faz 1b, 11.10.2026).
 * Personel × gün; L Lojistik, A Ambalaj, E eksik çıkış. Ücret alanları yalnız "Personel Ücretleri" yetkisine dolu gelir.
 */

export interface PuantajGunu {
    gun: number
    /** "yyyy-MM-dd" */
    tarih: string
    /** Haftanın günü; ekranda gösterim ve gölgelendirme tarihten hesaplanır (numaralandırmaya bağlı kalmamak için). */
    haftaGunu: number
    ozelGun: { ad: string, tur: number } | null
}

export interface PuantajPersonelGunu {
    gun: number
    /** L Lojistik, A Ambalaj, E eksik çıkış; Faz 2'de ofis / araç günü için sunucu başka harf gönderebilir. */
    kod: string | null
    ekDk: number
    normalDk: number
}

export interface PuantajToplami {
    calisilanGun: number
    normalDk: number
    ekDkLojistik: number
    ekDkAmbalaj: number
    /** Ofis ve araç QR'ıyla yapılan personel ek mesaisi (QR Mesai Faz 2); eski sunucuda gelmeyebilir. */
    ekDkDiger?: number | null
    eksikCikis: number
    ekMesaiUcreti: number | null
}

export interface PuantajPersoneli {
    personnelId: string
    adSoyad: string
    gorevi: string | null
    saatlikUcret: number | null
    gunler: PuantajPersonelGunu[]
    toplam: PuantajToplami
}

export interface AylikPuantaj {
    gunler: PuantajGunu[]
    personeller: PuantajPersoneli[]
}

interface Yanit<T> { isSuccess: boolean, message?: string, data: T }

const cagir = async <T>(uc: string, govde: any = {}): Promise<Yanit<T>> => {
    try {
        console.log('SERVICE CALL - Puantaj/' + uc, JSON.stringify(govde));
        const resp = await axios.post(Helpers.getEndpoint() + '/Puantaj/' + uc, govde);
        return Helpers.dataParser(resp);
    } catch (error) {
        throw Helpers.parseErrorMessage(error);
    }
}

export class PuantajService {
    static aylik = (yil: number, ay: number) => cagir<AylikPuantaj>('Aylik', { yil, ay });
    /** Diğer Excel uçları gibi oluşan dosyanın adını döner (indirme: /Excels/{ad}). */
    static excel = (yil: number, ay: number) => cagir<string>('Excel', { yil, ay });
}
